'use strict';

import GraphQL from './graphql';

export default {
  create (
    personId,
    notes,
    declineToProsecuteNonViolentCrimesStatus,
    endCashBailStatus,
    treatKidsLikeKidsStatus,
    considerImmigrationConsequencesStatus,
    beTransparentAndAccountableStatus,
    holdPoliceAccountableStatus
  ) {
    const query = `mutation {
      createIssueSubmission(
        personId: ${personId},
        notes: "${notes}",
        declineToProsecuteNonViolentCrimesStatus: "${declineToProsecuteNonViolentCrimesStatus}",
        endCashBailStatus: "${endCashBailStatus}",
        treatKidsLikeKidsStatus: "${treatKidsLikeKidsStatus}",
        considerImmigrationConsequencesStatus: "${considerImmigrationConsequencesStatus}",
        beTransparentAndAccountableStatus: "${beTransparentAndAccountableStatus}",
        holdPoliceAccountableStatus: "${holdPoliceAccountableStatus}"
      ) {
          id
          person_id
          user_id
          notes
          decline_to_prosecute_non_violent_crimes_status
          end_cash_bail_status
          treat_kids_like_kids_status
          consider_immigration_consequences_status
          be_transparent_and_accountable_status
          hold_police_accountable_status
          errors
        }
    }`;

    return GraphQL.post(query);
  },

};



// WEBPACK FOOTER //
// ./app/javascript/vue/services/issue-submissions.js